(function() {
  function getUrl() {
    try {
      return new URL(window.location.href);
    } catch (error) {
      return null;
    }
  }

  function removeSuccessMarker(url) {
    if (!url || !window.history || !window.history.replaceState) return;

    url.searchParams.delete('footer_newsletter');
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
  }

  function showSuccess() {
    var form = document.getElementById('newsletter-footer');
    if (!form) return;

    var field = form.querySelector('.footer__newsletter');
    var success = form.querySelector('[data-footer-newsletter-success]');
    var error = form.querySelector('[data-footer-newsletter-error]');

    if (field) field.hidden = true;
    if (error) error.hidden = true;
    if (success) success.hidden = false;

    document.dispatchEvent(new CustomEvent('newsletter:footerSuccess'));
  }

  function init() {
    var url = getUrl();
    if (!url || url.searchParams.get('footer_newsletter') !== 'success') return;

    showSuccess();
    removeSuccessMarker(url);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
